<template>
  <div>
    <table-base ref="table" :GetAction="'GetSeachList'" :Controller="'Role'" SaveAction="SaveRole" DelAction="DelRole" :TopButtons="TopButtons" :FormParams="FormParams" TableButtonWidth="180px"
    :TopSeach="TopSeach" :TableColumns="TableColumns" :TableButtons="TableButtons" @tableButtonClick="tableButtonClick"></table-base>
    <el-dialog title="权限设置" :append-to-body="true" :visible="ShowTree" width="30%" :close-on-click-modal="false" :before-close="()=>{ShowTree = false;}">
      <base-tree  v-if="ShowTree" :TreeData.sync="treeData" :showFile="true" :defaultCheck.sync="defaultCheck" @TreeSave="TreeSave" @TreeOut="ShowTree = false"></base-tree>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Role",
  title: "管理员角色",
  data () {
    return {
      ShowTree: false,
      treeData: [],
      defaultCheck: [],
      model: {},
      TopButtons: [
        { name: "添加", action: "add", type: "primary" }
      ],
      TopSeach: [
        { name: "", param: "input", default: "", type: "text", placeholder: "请输入关键字" },
      ],
      TableColumns: [
        { name: "序号", type: "index", param: "", width: "50px" },
        { name: "角色名称", param: "name" }
      ],
      TableButtons: [
        { name: "编辑", action: "update" },
        { name: "设置权限", action: "setPower" },
        { name: "删除", action: "del", color: "#f56c6c" },
      ],
      FormParams: [
        { name: "角色名称", param: "name", default: "", placeholder: "请输入角色名称" },
      ]
    }
  },

  components: {
    TableBase: resolve => require(["@/components/System/components/TableBase"], resolve),
    BaseTree: resolve => require(["@/components/System/components/BaseTree"], resolve),
  },
  mounted () {

  },
  methods: {
    tableButtonClick (row, type) {
      if (type == "setPower") {
        this.model = row;
        this.LoadPower();
        if (row.meuns) {
          this.defaultCheck = row.meuns.split(',');
        } else {
          this.defaultCheck = [];
        }
        this.ShowTree = true;
      }
    },
    LoadPower () {
      if (this.treeData.length == 0) {
        this.Ajax.Get("api/Menu/GetMenuTree/00000000-0000-0000-0000-000000000000").then(res => {
          this.treeData = res.data;
        });
      }
    },
    TreeSave (dt) {
      var menus = "";
      dt.forEach(item => {
        menus += item.id + ",";
      });
      if (menus.endsWith(',')) {
        menus = menus.substr(0, menus.length - 1);
      }
      this.model.meuns = menus;
      this.Ajax.Post("api/Role/SaveRole", this.model).then(res => {
        this.$tool.System.msg("设置成功！", "提示", 0);
        this.ShowTree = false;
        this.$refs.table.GetList();
      })
    }
  },
}
</script>